import React from 'react';
import {getScanners, startSmartLabCalibration, resetTestConnect} from 'services/testConnect';
import {getState} from 'services/testConnectState';
import ReactDOM from 'react-dom';
import moment from 'moment';
import Header from 'components/layout/header';
import LoadingButton from 'components/loadingBtn';
import {calibration} from 'helpers/scanHelpers';
import events from 'lib/events';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import Loader from 'components/loader';
import session from 'services/sessionService';
import IntlWrapper from 'components/layout/intlWrapper';
import {FormattedMessage, FormattedHTMLMessage, intlShape, injectIntl} from 'react-intl';

let render = container => {
  console.info('[UI.page.tools.calibration] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperCalibration/></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools.calibration] register route');
router.rr.add([{path: 'tools/calibration', handler: routeUtils.requireAuth(render)}]);

class Calibration extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  static displayName = 'Calibration';

  state = {
    ccDate: null,
    scannerInitialized: false,
    scanInProgress: false,

    accuscanConnected: false,
    smartlabConnected: false,
    smartlabStarted: false,
  };

  componentDidMount() {
    this.initializeScanner();
    this.titrationTestingListener = events.subscribe('dealeruser.toggleTitrationTestingOnly', () => this.initializeScanner());
  }

  componentWillUnmount() {
    if (this.titrationTestingListener && this.titrationTestingListener.remove) {
      this.titrationTestingListener.remove();
    }
  }

  accusanInstructions = () => {
    const {formatMessage} = this.props.intl;
    let button, message;

    if (!this.state.accuscanConnected) {
      button =
        <p>
          <FormattedMessage id='tools.calibration.copper.connect'/>
        </p>;
    } else {
      button =
        <a className='btn btn-primary'
           href='#tools/calibration/accuscan'><FormattedMessage id="tools.start.calibration"/></a>;
    }

    if (this.state.ccDate && (typeof this.state.ccDate === 'string' || this.state.ccDate.diff(moment(), 'days') >= 90)) {
      message =
        <p className='b'><FormattedMessage id="tools.calibration.accuscan.needs-calibration"/></p>;
    }

    return <div>
      {message}
      <p><FormattedMessage id="tools.calibration.calibration.procedure"/></p>
      <p><FormattedMessage id="tools.calibration.last.done"
                           values={{
                             date: <strong>
                               {this.state.ccDate ? this.state.ccDate.format('ll') : `(${formatMessage({id: 'general.never'})})`}
                             </strong>,
                           }}/></p>
      {button}
    </div>;
  };

  handleScannerData = data => {
    this.setState(Object.assign(this.state, data));
  };

  initializeScanner = () => {
    if (!session.getUser().titrationTestingOnly) {
      getScanners()
        .then(data => {
          if (!data || !data.scanners) {
            this.setState({
              scannerInitialized: true,
              accuscanConnected: false,
              smartlabConnected: false,
            });
            return;
          }

          events.subscribe('scanner.complete', () => {
            this.handleScannerData(getState());
            resetTestConnect(!session.getUser().titrationTestingOnly);
          });

          this.setState({
            scannerInitialized: true,
            accuscanConnected: data.scanners.includes('Accuscan'),
            smartlabConnected: data.scanners.includes('SmartLab'),
            ccDate: moment(data.calibrationDate),
          });
        })
        .catch(err => {
          console.error(err);
          this.setState({
            scannerInitialized: true,
            smartlabConnected: false,
            accuscanConnected: false,
          });
        });
    } else {
      this.setState({
        scannerInitialized: true,
        smartlabConnected: false,
        accuscanConnected: false,
      });
    }
  };

  smartlabFields = () => {
    if (!this.state.smartlabStarted) {
      return null;
    }

    return <table className='table-biolab table-striped'>
      <thead>
        <tr>
          <th><FormattedMessage id="tools.calibration.field"/></th>
          <th><FormattedMessage id="tools.calibration.calibration.results"/></th>
        </tr>
      </thead>
      <tbody>
        {calibration.chlorine.map(row =>
          <tr key={row.name}>
            <td>{row.name}</td>
            <td>{this.state[row.field] || '-'}</td>
          </tr>)}
      </tbody>
    </table>;
  };

  smartlabInstructions = () => {
    const {formatMessage} = this.props.intl;

    if (!this.state.smartlabConnected) {
      return <p><FormattedMessage id='tools.calibration.smartlab.connect' /></p>;
    }

    return <div>
      <ol>
        <li>
          <FormattedHTMLMessage id='tools.calibration.instructions.step1' values={{
            disk: <i>{formatMessage({id: 'tools.calibration.check-disk'})}</i>,
          }} />
        </li>
        <li>
          <FormattedMessage id='tools.calibration.instructions.step2' values={{
            disk: <i>{formatMessage({id: 'tools.calibration.check-disk'})}</i>,
          }} />
        </li>
        <li>
          <FormattedMessage id='tools.calibration.instructions.step3' values={{
            buttonName: <i>{formatMessage({id: 'general.start.scan'})}</i>,
          }} />
        </li>
        <li>
          <FormattedMessage id='tools.calibration.instructions.step4' values={{
            disk: <i>{formatMessage({id: 'tools.calibration.check-disk'})}</i>,
          }} />
        </li>
      </ol>
      <p>
        <LoadingButton
          className='btn btn-primary'
          onClick={this.smartlabStartScan}
          loading={this.state.scanInProgress}
          disabled={this.state.scanInProgress}>
          <FormattedMessage id="tools.start.calibration"/>
        </LoadingButton>
      </p>
      {this.smartlabFields()}
      <br/>
    </div>;
  };

  smartlabStartScan = () => {
    startSmartLabCalibration();
    this.setState({smartlabStarted: true});
  };

  render() {
    if (this.state.securityError) {
      return <div className='container'>
        <h3><FormattedMessage id="tools.calibration.complete.test"/></h3>
        <br/>
        <p><a className='btn btn-default'
              href='#support/ie-security-error'><FormattedMessage id="general.click.troubleshoot"/></a></p>
      </div>;
    }

    return <div className='calibration-page container'>
      <Header mainTitle={this.props.intl.formatMessage({id: 'tools.title'})}
              subTitle={this.props.intl.formatMessage({id: 'general.calibration'})}
              fallbackMainTitleReturn='tools'/>
      <div className='row'>
        <Loader loaded={this.state.scannerInitialized}>
          <div className='container'>
            <h2>Smart Lab<sup>&#8482;</sup> <FormattedMessage id="general.calibration"/></h2>
            <div className='col-sm-12'>
              {this.smartlabInstructions()}
            </div>
          </div>
          <hr/>
          <div className='container'>
            <h2>AccuScan<sup>&reg;</sup> II <FormattedMessage id="tools.cooper.calibration"/></h2>
            <div className='col-sm-12'>
              {this.accusanInstructions()}
            </div>
          </div>
        </Loader>
      </div>
    </div>;
  }
}

const WrapperCalibration = injectIntl(Calibration);

export default WrapperCalibration;
